import { Fragment } from "react";
import { CustomSvgIcon } from "sipli-fleet-core/components";
import crossIconCustom from "sipli-fleet-core/assets/icons/custom-modal-cross-icon.svg?url";

const STEP_CONNECTOR_WIDTH = 157;

const StepIndicator = ({
  index,
  label,
  active,
  clickable,
  onClick,
}: {
  index: number;
  label: string;
  active: boolean;
  clickable?: boolean;
  onClick?: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!clickable}
    className={`flex items-center gap-2 bg-transparent p-0 text-left ${
      clickable ? "cursor-pointer" : "cursor-default"
    }`}
  >
    <span
      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold ${
        active ? "bg-primary text-white" : "border border-gray3 text-gray6"
      }`}
    >
      {index}
    </span>
    <span className={`text-base font-semibold ${active ? "text-gray10" : "text-gray6"}`}>
      {label}
    </span>
  </button>
);

export interface ModalStepHeaderProps {
  steps: string[];
  current: number;
  onClose: () => void;
  closeLabel?: string;
  onStepClick?: (step: number) => void;
}

const ModalStepHeader = ({
  steps,
  current,
  onClose,
  closeLabel,
  onStepClick,
}: ModalStepHeaderProps) => (
  <div className="mb-6 flex items-center">
    {steps.map((label, index) => (
      <Fragment key={label}>
        <StepIndicator
          index={index + 1}
          label={label}
          active={current === index}
          clickable={Boolean(onStepClick) && index !== current}
          onClick={index !== current ? () => onStepClick?.(index) : undefined}
        />
        {index < steps.length - 1 ? (
          <span
            className="mx-3 h-px shrink-0 bg-gray3"
            style={{ width: STEP_CONNECTOR_WIDTH }}
          />
        ) : null}
      </Fragment>
    ))}
    <button type="button" onClick={onClose} aria-label={closeLabel} className="ml-auto shrink-0">
      <CustomSvgIcon src={crossIconCustom} className="cursor-pointer" />
    </button>
  </div>
);

export default ModalStepHeader;
